/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import { Form } from 'react-bootstrap';
import './style.css';

export interface ICheckListsProps {
  data?: string[];
}

export const CheckLists = (props: ICheckListsProps) => {
  const { data } = props;
  const _renderItems = () => {
    let _temp =
      Array.isArray(data) &&
      data?.map((item) => {
        return <Form.Check checked type={'checkbox'} disabled label={item} />;
      });
    return _temp;
  };

  return <>{_renderItems()}</>;
};

CheckLists.defaultProps = {};
